import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineAsyncComponent } from 'vue';
import { scripts } from '@/helpers/APIconnection';
export default {
  props: {
    ExecutionController: Function,
    robotekaScriptsEnvironment: Boolean,
    back: Object
  },
  computed: {
    title() {
      return this.currentSection.title ?? this.$st(this.flow?.name);
    },
    subtitle() {
      return this.flow?.limits || this.flow?.description ? this.$t(this.flow?.limits || this.flow?.description) : this.currentSection.subtitle;
    },
    loading() {
      return this.$state.flowLauncherController.loading;
    },
    component() {
      const component = this.currentSection.template;
      if (!component) return;
      return defineAsyncComponent(() => import('@/components/script_templates/sections/' + component));
    },
    InputComponents() {
      const components = {};
      this.flow.sectionSetup.builder.forEach(s => s.builder?.forEach((c, componentIndex) => {
        if (this.robotekaScriptsEnvironment && c.template === 'SelectionDialog') c.config.embedded = false; // File selection embedded option fixed in roboteka scripts
        if (!this.$embedded && c.template === 'SelectionDialog' && c.config.directory) c.hidden = true; // Folder selection hidden in web

        if (!c.ref) {
          c.ref = c.key ?? Math.floor(Math.random() * 900000) + 100000;
        }
        components[c.ref] = c;
        c.order = componentIndex;
      }));
      return components;
    },
    InputValues() {
      return Object.fromEntries(Object.values(this.InputComponents).map(c => {
        return [c.ref, c.value];
      })) || {};
    }
  },
  data: function () {
    return {
      flow: this.$state.flowLauncherController.flow,
      currentSection: {},
      sections: {
        general: [{
          ref: 'error',
          template: 'ErrorSection',
          stepbar: false
        }, {
          ref: 'output',
          template: 'OutputSection',
          stepbar: true
        }]
      },
      modals: {
        current: undefined
      },
      scheduledData: undefined,
      openConfig: true,
      newConfigurationName: undefined,
      configurations: undefined
    };
  },
  created() {
    this.sections.dynamic = this.flow?.sectionSetup.builder.filter(step => !step.hidden); // Set the dynamic steps filtering by hidden
    this.sections.dynamic.forEach((item, index) => {
      item.index = index; // Save index value in section data
      // >> Add here data for each step
    });
    this.ChangeSection({
      index: 0
    }); // >> Change to first section

    // this.GetScriptsConfiguration()
  },
  methods: {
    ChangeSection: function (section, params) {
      // >> Change section by ref
      if (section?.ref !== undefined) {
        this.currentSection = this.sections.dynamic.concat(this.sections.general).find(section_ => section_.ref === section.ref);
      } else if (section?.index !== undefined) {
        this.currentSection = this.sections.dynamic[section.index];
      } else if (section) {
        // >> Change section to previous or following one

        const currentStepIndex = this.sections.dynamic.findIndex(section_ => this.currentSection.ref === section_.ref);
        this.currentSection = currentStepIndex !== undefined ? this.sections.dynamic[Math.min(Math.max(currentStepIndex + section, 0), this.sections.dynamic.length - 1)] : this.sections.dynamic[0];
      } else {
        this.currentSection = this.sections.dynamic[0].template === 'TutorialSection' ? this.sections.dynamic[1] : this.sections.dynamic[0];
      }

      // Save received params in section data
      if (params) {
        this.currentSection.params = Object.assign(this.currentSection.params ?? {}, params);
      }
      if (!this.currentSection) {
        this.currentSection = {};
      }
    },
    GetNormalizedInputValues: async function () {
      for (const item of Object.values(this.InputComponents)) {
        if (item.getValue) item.value = await item.getValue();
      }
      return this.InputValues;
    },
    LaunchScript: async function (args, json) {
      this.$state.flowLauncherController.loading = true;
      this.$state.flowLauncherController.ui = {};
      const executionParams = {
        step: this.currentSection.ref,
        token: this.$state.flowLauncherController.output?.executionToken,
        arguments: args ?? (await this.GetNormalizedInputValues()),
        // Object key-value
        inputs: this.InputComponents,
        json
      };
      const response = await this.ExecutionController(executionParams);
      if (!response?.status) {
        this.$state.flowLauncherController.loading = false;
        return;
      }
      this.$state.flowLauncherController.output = response?.data ?? {};
      this.$state.flowLauncherController.output.status = response.status; // Save in executionOutput the result status code

      // Execution response redirect controller >>

      if (this.currentSection.router?.[response?.status]) {
        this.ChangeSection({
          ref: this.currentSection.router[response.status]
        });
      } // Section router
      else if (response?.status === 200) {
        this.ChangeSection({
          ref: 'output'
        });
      } else if (response?.status === 242) {
        this.ChangeSection({
          ref: 'error'
        }, {
          type: 'result'
        });
      } else if (response?.status === 400 || response?.status === 401 || response?.status === 500) {
        this.ChangeSection({
          ref: 'error'
        });
      } else if (response?.status === 402) {
        this.OnPaymentError();
      } else if (response?.status === 504) {
        this.ChangeSection({
          ref: 'error'
        }, {
          type: 'timeout'
        });
      } else {
        this.ChangeSection({
          ref: 'error'
        });
      }
      this.$state.flowLauncherController.loading = false;
    },
    RepeatTask: function () {
      this.$state.flowLauncherController.console = false; // Close console
      this.$state.flowLauncherController.output = undefined; // Reset output data on repeat

      const to = this.flow?.sectionSetup.resetTo ? {
        ref: this.flow?.sectionSetup.resetTo
      } : undefined;
      this.ChangeSection(to);
    },
    BackButtonCallback: function () {
      if (this.back) {
        this.back();
      } else if (this.currentSection.index === 0) {
        this.$router.go(-1);
      } else if (this.currentSection.backTo) {
        this.ChangeSection({
          ref: this.currentSection.backTo
        });
      } else {
        this.ChangeSection(-1);
      }
    },
    OnPaymentError: function () {
      this.$state.ui.promptModal = {
        title: this.$st('payments.modals.insufficient-slans.title'),
        text: this.$st('payments.modals.insufficient-slans.text'),
        footer: [{
          click: () => this.$state.ui.promptModal = undefined,
          text: this.$st('payments.modals.insufficient-slans.continue'),
          variant: 'outlined',
          stretch: true
        }, {
          click: () => {
            this.$router.push({
              name: 'Payments'
            });
            this.$state.ui.promptModal = undefined;
          },
          text: this.$st('payments.modals.insufficient-slans.see-plans'),
          stretch: true
        }]
      };
    },
    // ====== Scheduler ======

    ToggleScheduler: function () {
      this.modals.current = this.modals.current === "scheduler-modal" ? undefined : 'scheduler-modal';
    },
    OnScheduleCreated: async function () {
      if (!this.scheduledData?.scheduledDate) return;
      const executionParams = {
        arguments: await this.GetNormalizedInputValues(),
        // Object key-value
        inputs: this.InputComponents,
        schedule: this.scheduledData
      };
      await this.ExecutionController(executionParams);
      this.modals.current = undefined;
    },
    // ===============| Email Configuration |===============

    OpenEmailConfigurationModal: function () {
      this.GetEmailConfiguration();
      this.modals.current = 'email-auth-modal';
    },
    GetScriptsConfiguration: async function () {
      const response = await scripts.getSettings(this.$state.flowLauncherController.flow._id);
      if (response?.status === 200) {
        this.configurations = response.data?.items;
        Object.values(this.configurations ?? {}).forEach(c => {
          if (!(typeof c.settings === 'object' && !Array.isArray(c.settings))) {
            c.error = true;
          }
        });
      }
    },
    CreateConfiguration: async function () {
      if (!this.$validate('configuration')) return;
      const response = await scripts.createSetting(this.$state.flowLauncherController.flow._id, {
        name: this.newConfigurationName,
        data: this.InputValues
      });
      if (response?.status === 200) {
        this.newConfigurationName = undefined;
      }
    },
    ImportConfiguration: function (config) {
      if (typeof config.settings === 'object' && !Array.isArray(config.settings)) {
        Object.entries(config.settings).forEach(s => {
          const input = this.InputComponents[s[0]];
          if (input) input.value = s[1];
        });
      }
    },
    DeleteConfiguration: async function (config) {
      config.removing = true;
      const response = await scripts.deleteSetting(config._id);
      if (response?.status === 200) {
        delete this.configurations[config._id];
      }
      config.removing = true;
    }
  }
};